import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ConnectedRouter } from "connected-react-router";
import { history } from "./config/history";
import { store } from "./config/store";
import { Provider } from "react-redux";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ThemeProvider } from "@mui/system";
import { theme } from "./theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <DndProvider backend={HTML5Backend}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </DndProvider>
    </ThemeProvider>
  </Provider>
);
